import React from "react";
// import { Link } from "react-router-dom";
import { connect } from "react-redux";
import * as actions from "../../actions";
import Chip from "@material-ui/core/Chip";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faPen,
  faPlus,
  faTrash
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

import Spinner from "../app/Spinner";
import Modal from "../app/Modal";
import UserForm from "./UserForm";
import UserDelete from "./UserDelete";
import LocationForm from "./LocationForm";
import LocationDelete from "./LocationDelete";

class Locations extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      form: null,
      modalOpen: false,
      user: this.props.auth.email,
      data: []
    };
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleCloseReload = this.handleCloseReload.bind(this);
    this.handleCloseDelete = this.handleCloseDelete.bind(this);
  }

  componentDidMount() {
    this.props.fetchUser();
    this.props.fetchLocationUsers(this.props.match.params.id);
  }

  handleOpen() {
    this.setState({ modalOpen: true });
  }

  handleClose() {
    this.setState({ modalOpen: false });
  }

  handleCloseReload = () => {
    this.setState({ modalOpen: false });
    this.props.fetchLocationUsers(this.props.match.params.id);
  };

  handleCloseDelete = () => {
    this.setState({ modalOpen: false });
    this.props.history.push("/");
  };

  render() {
    // ***************************
    // ADD MENU FUNCTIONALITY
    const handleAddUser = () => {
      this.setState({ form: "add", modalOpen: true });
    };

    const handleEditUser = e => {
      this.setState({
        data: this.props.locationUsers[e.currentTarget.id],
        form: "edit",
        modalOpen: true
      });
    };

    const handleDeleteUser = e => {
      this.setState({
        data: this.props.locationUsers[e.currentTarget.id],
        form: "delete",
        modalOpen: true
      });
    };

    const handleEditLocation = e => {
      this.setState({
        data: this.props.locationUsers[0],
        form: "edit-location",
        modalOpen: true
      });
    };

    const handleDeleteLocation = e => {
      this.setState({
        data: this.props.locationUsers[0],
        form: "delete-location",
        modalOpen: true
      });
    };

    const renderPlaceholder = () => {
      return <Spinner />;
    };

    const renderForm = type => {
      switch (type) {
        case "add":
          return (
            <div>
              <UserForm
                data=""
                subscriptionId={this.props.locationUsers[0].SubscriptionId.Oid}
                handleClose={this.handleClose}
                handleCloseReload={this.handleCloseReload}
              />
            </div>
          );
        case "edit":
          return (
            <div>
              <UserForm
                data={this.state.data}
                subscriptionId={this.props.locationUsers[0].SubscriptionId.Oid}
                handleClose={this.handleClose}
                handleCloseReload={this.handleCloseReload}
              />
            </div>
          );
        case "delete":
          return (
            <div>
              <UserDelete
                data={this.state.data}
                handleClose={this.handleClose}
                handleCloseReload={this.handleCloseReload}
              />
            </div>
          );
        case "edit-location":
          // return renderEditForm();
          return (
            <div>
              <LocationForm
                data={this.state.data}
                subscriptionId={
                  this.props.locationUsers[0].SubscriptionId.SubscriptionId
                }
                userId={this.state.user}
                handleClose={this.handleClose}
                handleCloseReload={this.handleCloseReload}
              />
            </div>
          );
        case "delete-location":
          return (
            <div>
              <LocationDelete
                data={this.state.data}
                handleClose={this.handleClose}
                handleCloseDelete={this.handleCloseDelete}
              />
            </div>
          );
        default:
          return renderPlaceholder();
      }
    };

    const renderResults = data => {
      let output = "";
      //console.log(data);
      if (data) {
        output = data.map((record, index) => {
          let isAdmin = "";
          if (record.Admin === true) {
            isAdmin = (
              <Chip
                size="small"
                label="Admin"
                color="primary"
                className="pull-right"
              />
            );
          }
          return (
            <div key={index} className="item">
              <div className="item-details">
                <div className="item-name">
                  {record.Email} {isAdmin}
                </div>
              </div>
              <div className="panel-actions">
                <button
                  className="waves-effect waves-light btn btn-small"
                  onMouseDown={handleEditUser}
                  id={index}
                >
                  <FontAwesomeIcon icon={faPen} size="lg" />
                </button>
                &nbsp;
                <button
                  className="waves-effect waves-light btn btn-small"
                  onMouseDown={handleDeleteUser}
                  id={index}
                >
                  <FontAwesomeIcon icon={faTrash} size="lg" />
                </button>
              </div>
            </div>
          );
        });
      }
      return output;
    };

    const renderContent = () => {
      let pageTitle = "";
      if (this.props.locationUsers) {
        pageTitle = this.props.locationUsers[0].SubscriptionId.Business;
      }
      return (
        <div>
          <Link className="waves-effect waves-light btn" to="/">
            <FontAwesomeIcon icon={faChevronLeft} size="lg" /> Back to Locations
          </Link>
          <div className="component-group">
            <h1>{pageTitle}</h1>
            <div className="component-actions">
              <button
                className="waves-effect waves-light btn"
                onMouseDown={handleEditLocation}
                id="0"
              >
                <FontAwesomeIcon icon={faPen} size="lg" />
              </button>
              &nbsp;
              <button
                className="waves-effect waves-light btn"
                onMouseDown={handleDeleteLocation}
                id="0"
              >
                <FontAwesomeIcon icon={faTrash} size="lg" />
              </button>
            </div>
            <div className="panel-container component-shadow">
              <div className="panel-header">
                <div className="panel-title">Users</div>
                <div className="panel-actions">
                  <button
                    className="waves-effect waves-light btn btn-small"
                    onMouseDown={handleAddUser}
                  >
                    <FontAwesomeIcon icon={faPlus} size="lg" /> Add User
                  </button>
                </div>
              </div>
              <div className="panel-content">
                {renderResults(this.props.locationUsers)}
              </div>
            </div>
          </div>
        </div>
      );
    };

    return (
      <div className="component-groups pad-20">
        {renderContent()}
        <Modal modalOpen={this.state.modalOpen}>
          {renderForm(this.state.form, this.state.data)}
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    locationUsers: state.locationUsers
  };
}

export default connect(
  mapStateToProps,
  actions
)(Locations);
